import { AxiosError } from 'axios';
import { POST_SEND_UNIQUE_LINK_EMAIL_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface SendUniqueLinkEmailFormData {
  isWaiveSubjectAdminFee: boolean;
  isWaiveLateFee: boolean;
  isOfflinePayment: boolean | null | undefined;
  expiryDate?: string;
  description?: string;
}

export interface SubjectsData {
  subjectCode: string;
  examSeriesUuid: string | null;
  optionalPaperUuid: (string | null)[];
}

export interface SendUniqueLinkEmailRequest extends SendUniqueLinkEmailFormData {
  userType: string;
  examLevelUuid?: string;
  uuid: string;
  applicationType: string;
  exemptionRuleUuids?: string[];
  subjects?: SubjectsData[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSendUniqueLinkEmail = ({ onSuccess, onError }: Input = {}) => {
  const postSendUniqueLink = async (requestBody: SendUniqueLinkEmailRequest) => {
    const res = await axiosClient.post<void>(POST_SEND_UNIQUE_LINK_EMAIL_URL, requestBody);

    return res.data;
  };

  return useCustomMutation(postSendUniqueLink, {
    onSuccess,
    onError,
  });
};
